import React from "react";
import { SelectField, Show, SimpleShowLayout, TextField } from "react-admin";

import { useEnumSelectChoices } from "../../../components/_helpers/useEnumSelectChoices";
import { ActionsWithBackButton } from "../../../components/actionbars/ActionsWithBackButton";
import { DateTimeField } from "../../../components/fields/DateFormatField";
import { JsonTextField } from "../../../components/fields/JsonTextField";
import { AdminLogLevelType } from "../../../entities/AdminLogLevelType";
import { AdminLogModuleType } from "../../../entities/AdminLogModuleType";
import { AdminLogsDetails } from "../components/AdminLogsDetails";

export const AdminLogsShow = (props) => {
	const adminLogLevelChoices = useEnumSelectChoices(AdminLogLevelType, "log-level");
	const adminModuleChoices = useEnumSelectChoices(AdminLogModuleType, "log-module");

	return (
		<Show actions={<ActionsWithBackButton />} {...props}>
			<AdminLogsDetails />
		</Show>
	);
};
